$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  createBurgerIcon();
  customSearchBar();
  customSignup();
});

// --------------------------------
// Custom burger menu
function createBurgerIcon() {
  $.each(new Array(3), function () {
    $('.header .mobile-nav-toggle').append('<span class="burger-line"></span>');
  });
}

// Searchbox scripts
function customSearchBar() {
  let searchPlaceholder = 'Search Website';

  $('.header .searchBox input').val('');
  $('.header .searchBox input').attr('placeholder', searchPlaceholder);
}

// Custom header signup
function customSignup() {
  $('.header .emailSignup .emailSubmitButton')
    .removeClass('button')
    .text('')
    .attr('aria-label', 'Sign up for updates')
    .attr('tabindex', '0');
}

// function to validate external Links
export function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

export function validateWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(window).width() >= breakpoint;
}
